
import React, { ReactNode } from 'react';
import Navbar from '../components/navigation/Navbar';
import Footer from '../components/Footer';
import WWWRedirect from '../components/WWWRedirect';
import { Toaster } from "@/components/ui/toaster";

interface MainLayoutProps {
  children: ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <>
      <WWWRedirect />
      <Navbar />
      <main>
        {children}
      </main>
      <Footer />
      <Toaster />
    </>
  );
};

export default MainLayout;
